import { LayoutPage } from '@/entities/LayoutPage/ui/LayoutPage.jsx'
import './ui/LayoutPage.scss'
export default LayoutPage
